import { Color, DefaultValue } from '@billy/design-system'
import styled from '@emotion/styled'
import { transparentize } from 'polished'

export type Direction = 'row' | 'column'

export const MissingInformationWrapper = styled.div`
  display: flex;
  padding-top: 12px;
  padding-bottom: 20px;
`

export const FileWrapper = styled.div``

export const File = styled.div`
  flex-shrink: 0;
  width: 170px;
  height: 200px;
  margin-right: 32px;
  padding: 2px;
  border: 1px solid ${transparentize(0.9, Color.Black)};
  border-radius: ${DefaultValue.BorderRadius};
  background-color: ${Color.White};
`

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-top: 26px;
`

export const NotificationWrapper = styled.div`
  margin-bottom: 16px;
`
